import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { Colors, Inset } from '@doordash/design-language'

import { DeliveryIssueStatus } from '../../../../models/types'

type StyledListCellMenuItemProps = {
  status: DeliveryIssueStatus
}

export const StyledListCellMenuItem = styled.div`
  // When passing "onClick" to list component cell,
  // it creates a button div that hides this styled components background color

  button,
  button:hover {
    background-color: ${(props: StyledListCellMenuItemProps) =>
      props.status === DeliveryIssueStatus.Unread
        ? Colors.SystemBlue5
        : Colors.SystemWhite};
  }
`
export const StyledStatusIndicator = styled.div`
  display: flex;
  align-items: center;
  width: 7px;
  height: 100%;
  svg {
    max-height: 19px;
  }
`

export const UndecoratedLink = styled(Link)`
  text-decoration: none;
  display: block;
`

export const BlackTextLink = styled(Link)`
  color: ${Colors.TextPrimary};
  display: block;
`

export const StickyTop = styled.div`
  z-index: 2;
  position: sticky;
  top: 0;
  background-color: ${Colors.PageBackgroundPrimary};
`

export const NavBarHeaderTitle = styled.div`
  padding: 0 ${Inset.Sizes.Small}px;
`
export const CircleIconIndicatorContainer = styled.div`
  margin-left: 7px;
`
